import script from "./AsignarEvaluadoresView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AsignarEvaluadoresView.vue?vue&type=script&setup=true&lang=ts"

import "./AsignarEvaluadoresView.vue?vue&type=style&index=0&id=512979eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-512979eb"]])

export default __exports__